import React from 'react';
import { 
  Globe, 
  Leaf, 
  BookOpen, 
  Utensils, 
  History, 
  ScanBarcode, 
  Store, 
  Camera 
} from 'lucide-react';

const ACTION_BUTTONS = [
  {
    id: 'database',
    label: 'Database',
    icon: Globe,
    bgColor: 'bg-blue-600',
  },
  {
    id: 'fresh',
    label: 'Fresh',
    icon: Leaf,
    bgColor: 'bg-lime-600',
  },
  {
    id: 'products',
    label: 'Products',
    icon: BookOpen,
    bgColor: 'bg-cyan-600',
  },
  {
    id: 'meals',
    label: 'Meals',
    icon: Utensils,
    bgColor: 'bg-orange-500',
  },
  {
    id: 'scanned',
    label: 'Scanned',
    icon: History,
    bgColor: 'bg-yellow-500',
  },
  {
    id: 'scan',
    label: 'Scan',
    icon: ScanBarcode,
    bgColor: 'bg-green-600',
  },
  {
    id: 'restaurant',
    label: 'Menu',
    icon: Store,
    bgColor: 'bg-red-500',
  },
  {
    id: 'photo',
    label: 'Photo',
    icon: Camera,
    bgColor: 'bg-amber-600',
  },
];

export function ActionButtons({ onAction, isExpired }) {
  return (
    <div className="grid grid-cols-4 gap-2">
      {ACTION_BUTTONS.map((button) => {
        const Icon = button.icon;
        return (
          <button
            key={button.id}
            onClick={() => onAction(button.id)}
            disabled={isExpired}
            className={`
              flex flex-col items-center justify-center gap-1.5 py-2.5 px-1 rounded-xl
              ${button.bgColor}
              hover:opacity-90 active:scale-95
              transition-all duration-200
              disabled:opacity-50 disabled:cursor-not-allowed
            `}
            data-testid={`nutrition-action-${button.id}`}
          >
            <Icon className="h-5 w-5 text-white" />
            <span className="text-white text-xs font-semibold">{button.label}</span>
          </button>
        );
      })}
    </div>
  );
}

export default ActionButtons;
